export function Clickable({ onPress, children }) {
    return <div className="pointer" onClick={() => { onPress !== undefined ? onPress() : console.log("PRESSED") }}>
        {children}
    </div>
}